import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, DatePicker, Modal } from 'antd';
import apiService from '../api/apiService';
import moment from 'moment';

const { Option } = Select;

const DealModel = ({ isOpen, onClose, onSave, initialData }) => {
  const [form] = Form.useForm();
  const [roomTypes, setRoomTypes] = useState([]);

  useEffect(() => {
    fetchRoomTypes();
  }, []);

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        dealName: initialData.deal_name || '',
        referenceNumber: initialData.reference_number || '',
        reservationsLeft: initialData.reservations_left || '',
        endDate: initialData.end_date ? moment(initialData.end_date) : null,
        roomType: initialData.room_type || '',
        status: initialData.status || '',
      });
    } else {
      form.resetFields();
    }
  }, [initialData, form]);

  const fetchRoomTypes = async () => {
    try {
      const response = await apiService.get('/rooms/');
      setRoomTypes(response);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveOrEdit = async values => {
    const newDeal = {
      reference_number: values.referenceNumber,
      deal_name: values.dealName,
      reservations_left: parseInt(values.reservationsLeft, 10),
      end_date: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
      room_type: values.roomType,
      status: values.status,
    };

    try {
      if (initialData) {
        const response = await apiService.put(
          `/deals/${initialData.id}/`,
          newDeal
        );
        onSave(response); // Pass updated data to parent
      } else {
        const response = await apiService.post('/deals/', newDeal);
        onSave(response); // Pass new data to parent
      }
    } catch (error) {
      console.log(error);
    } finally {
      onClose();
    }
  };

  return (
    <Modal
      centered
      open={isOpen}
      title={initialData ? 'Edit Deal' : 'Create a New Deal'}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          {initialData ? 'Update' : 'Save'}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleSaveOrEdit}>
        <Form.Item
          label="Deal Name"
          name="dealName"
          rules={[
            { required: true, message: 'Please enter the deal name' },
            {
              pattern: new RegExp(/^[a-zA-Z\s]+$/),
              message: 'Deal name must only contain letters and spaces',
            },
          ]}
        >
          <Input placeholder="Enter deal name" />
        </Form.Item>

        <Form.Item
          label="Reference Number"
          name="referenceNumber"
          rules={[
            { required: true, message: 'Please enter the reference number' },
            {
              pattern: new RegExp(/^[a-zA-Z0-9]+$/),
              message:
                'Reference number must be alphanumeric (letters and numbers only)',
            },
          ]}
        >
          <Input
            placeholder="Enter reference number"
            disabled={!!initialData}
          />
        </Form.Item>

        <Form.Item
          label="Room Type"
          name="roomType"
          rules={[{ required: true, message: 'Please select a room type' }]}
        >
          <Select placeholder="Select Room Type">
            {roomTypes.map(roomType => (
              <Option key={roomType.id} value={roomType.id}>
                Room {roomType.room_number} - {roomType.room_type.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Reservations Left"
          name="reservationsLeft"
          rules={[
            { required: true, message: 'Please enter reservations left' },
          ]}
        >
          <Input
            type="number"
            placeholder="Enter number of reservations left"
          />
        </Form.Item>

        <Form.Item
          label="End Date"
          name="endDate"
          rules={[{ required: true, message: 'Please select the end date' }]}
        >
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: 'Please select the status' }]}
        >
          <Select placeholder="Select Status">
            <Option value="active">Active</Option>
            <Option value="expired">Expired</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DealModel;
